module.exports = __webpack_public_path__ + "static/media/(H)-11-Capim-Dourado-bijuterias.121b5313.jpg";